import { FieldErrors } from 'react-hook-form';

import { ErrorMessage } from '@hookform/error-message';

import { Typography } from 'components/typography';

import { QuickQuoteInputs } from '../../types';

export function AutoTransportFieldError({
  errors,
  name,
}: {
  errors: FieldErrors<QuickQuoteInputs>;
  name: string;
}) {
  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ message }: { message: string }) => {
        if (!message) {
          return null;
        }

        return (
          <Typography variant='body-xs' className='text-error-500'>
            {message}
          </Typography>
        );
      }}
    />
  );
}
